import { Form, Formik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import {
  ButtonGroup,
  ButtonToolbar,
  Col,
  Container,
  Dropdown,
  OverlayTrigger,
  Row,
} from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { CustomDropdownStyle } from '../../app/components/styledComponents/StyledCustomDropdown';
import StyledSearchInput from '../../app/components/styledComponents/StyledSearchInput';
import { StyledProduct } from './assets/ProductStyled';
import { defaultListing } from './assets/productsUtil';
import {
  useAddCatalogueMutation,
  useDeleteInventoryTagMutation,
  useGetAllFloristForCatalogFilterQuery,
  useGetFloristListOfCatalogProductsQuery,
  usePostInventoryTagMutation,
  useUpdateProductStatusMutation,
  useUpdateProductStockStatusMutation
} from './productsApiSlice';
import { toast } from 'react-toastify';
import { ShopStyled } from '../shopSetting/assets/shopStyled';
import AddIcon from '../../app/components/svgIcons/AddIcon';
import NewTrashIcon from '../../app/components/svgIcons/NewTrashIcon';
import NewFilterIcon from '../../app/components/svgIcons/NewFilterIcon';
import ListViewIcon from '../../app/components/svgIcons/ListViewIcon';
import GridviewIcon from '../../app/components/svgIcons/GridviewIcon';
import TableViewIcon from '../../app/components/svgIcons/TableViewIcon';
import InfoIcon from '../../app/components/svgIcons/InfoIcon';
import EditIcon from '../../app/components/svgIcons/EditIcon';
import { StyledTooltip } from '../../app/components/styledComponents/StyledTooltip';
import FormikInputWithIcon from '../../app/components/formikComponents/FormikInputWithIcon';
import styled, { useTheme } from 'styled-components';
import StyledSwitch from '../../app/components/styledComponents/StyledSwitch';
import { useGetAllNewCategoriesMutation } from '../vendors/vendorsApiSlice';
import StyledText from '../../app/components/styledComponents/StyledText';
import NewCloseIcon from '../../app/components/svgIcons/NewCloseIcon';
import StyledButton from '../../app/components/styledComponents/StyledButton';
import StyledCheckbox from '../../app/components/checkbox/StyledCheckbox';
import FormikRangeSlider from '../../app/components/formikComponents/FormikRangeSlider';
import { useSelector } from 'react-redux';
import useAuth from '../../hooks/useAuth';
import Modal from '../../app/components/modal/Modal';
import * as Yup from 'yup';
import DeleteConfirmation from '../../app/components/popups/DeleteConfirmation';
import DeleteIcon from '../../app/components/svgIcons/DeleteIcon';
import { DropdownItem } from 'react-bootstrap';
import BottomArrow from '../../app/components/svgIcons/BottomArrow';
import CustomDateRangePicker from '../../app/components/datePicker/CustomDateRangePicker';
import { sub } from 'date-fns';
import StyledInput from '../../app/components/styledComponents/StyledInput';
import moment from 'moment';
import {
  getButtonHover,
  getColor,
  getDarkenColor,
  isAuthorized,
  isEmptyOrNullObj,
} from '../../utils/helper';
import ConfirmationModal from '../../app/components/popups/ConfirmationModal';
import _ from 'lodash';
import StyledToogleButton from '../../app/components/styledComponents/StyledToogleButton';

const sidebarList = [
  'Tags',
  'Category',
  'Status',
  'Default',
  'Price',
  'Catalog',
];

const cataLogSortOptions = ['Most Upvoted', 'Most Recently Added', 'Most Sold'];

const CatalogTagList = [
  { label: 'Products added to Catalog', value: 'contributed' },
  { label: 'Products selected from Catalog', value: 'catalogItem' },
];

const AddToProductButton = styled(ShopStyled.EditButton)`
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.11), 0 8px 16px 0 rgba(0, 0, 0, 0.12);
`;

const staticOrderMap = {
  'Top Tags': 1,
  'Flower Type': 2,
  'Occasion Tags': 3,
  'Item Tags': 4,
  'Color Tag': 5,
  'Food Items': 6,
  'Custom Tags': 7,
  Others: 8,
};

const renderInput = ({
  label,
  toolTip,
  component,
  isRequired,
  parentClass = '',
  hideToolTip = false,
}) => (
  <div className={`mb-3 ${parentClass ?? ''}`}>
    <ShopStyled.NewFormLabel>
      {hideToolTip ? (
        <span className={`title ${isRequired ? 'required' : ''}`}>{label}</span>
      ) : (
        <>
          <span className={`title ${isRequired ? 'required' : ''}`}>
            {label}
          </span>
          <OverlayTrigger
            overlay={<StyledTooltip>{toolTip || label}</StyledTooltip>}
          >
            <span className="cursor-pointer ms-3 ">
              <InfoIcon className="mb-1" />
            </span>
          </OverlayTrigger>
        </>
      )}
    </ShopStyled.NewFormLabel>

    {component}
  </div>
);

const ProductsHeader = ({
  isProduct,
  isCatalogue,
  isSelectProduct,
  selectedProducts,
  setSelectedProducts,
  onDeleteProducts = () => {},
  listing,
  setListing,
  view,
  setView,
  isComingFromEditTemplate,
  handleBulkEditTopTags,
  updating,
  getProductTags,
  onHandleButtonActionForTemplate = () => {},
  data,
  getName,
  refetch,
  setUpdatingTag,
  floristData,
  isProductFloristsFetching,
  addtoMyProducts,
  setAddtoMyProducts
}) => {
  const { user } = useAuth();

  const [addNewTag] = usePostInventoryTagMutation();
  const TAGS_FIELD_KEY = isCatalogue
    ? 'inventoryTagDTOS'
    : 'floristInventoryTagDTOS';
  const theme = useTheme();
  const formikRef = useRef();

  const [addCatalogueAPI] = useAddCatalogueMutation();
  const navigate = useNavigate();
  const location = useLocation();
  const [updateProductStatus] = useUpdateProductStatusMutation();
  const [updateProductStockStatus] = useUpdateProductStockStatusMutation();
  const [openUpdateStatusModal, setOpenUpdateStatusModal] = useState(false);
  const [updateStockStatusModal , setUpdateStockStatusModal] = useState(false);
  const productTags = useSelector((state) => state.productUtils.productTags);

  const initialCustomTag = {
    name: 'Custom Tags',
    notes: 'Custom Tags',
    description: 'Custom Tags',
    parentCategory: 0,
    floristId: user.floristId,
    childTags: [],
  };

  const tagsList = productTags
    ?.filter((option) => !option.parentCategory && option.childTags?.length > 0)
    .map((option) => ({
      ...option,
      childTags: option.childTags.map((childTag) => ({
        ...childTag,
        value: childTag.name,
        label: childTag.name,
      })),
    }));

  const otherTags = {
    name: 'Others',
    label: 'Others',
    title: 'Others',
    value: 'Others',
    childTags: productTags
      ?.filter(
        (option) =>
          !option.parentCategory &&
          (option.childTags ? option.childTags?.length === 0 : true),
      )
      .map((option) => ({
        ...option,
        value: option.name,
        label: option.name,
      })),
  };

  tagsList?.push(otherTags);

  if (!tagsList?.some((tag) => tag.name === 'Custom Tags')) {
    tagsList?.push(initialCustomTag);
  }

  tagsList?.sort((a, b) => {
    const orderA = staticOrderMap[a.name] || Infinity;
    const orderB = staticOrderMap[b.name] || Infinity;
    return orderA - orderB;
  });

  const initialNewTagValues = {
    name: '',
  }

  const [editTagValue, setEditTagValue] = useState(initialNewTagValues);

  const [initialSelectedTopTags, setInitialSelectedTopTags] = useState([]);
  const [selectedTopTags, setSelectedTopTags] = useState([]);
  const [productCategoryOptions, setProductCategoryOptions] = useState([]);
  const [selectedSort, setSelectedSort] = useState('Most Recent');
  const [showFilterDropDown, setShowFilterDropDown] = useState(false);
  const [filterValues, setFilterValues] = useState({});
  const [makeProductActive, setMakeProductActive] = useState(false);
  const [makeProductAvailable , setMakeProductAvailable] = useState(true);
  const [selectedFlorists, setSelectedFlorists] = useState([]);
  const [showFloristFliters, setShowFloristFilters] = useState(false);
  const [showAddTag, setShowAddTag] = useState(false);
  const [activeQuickFilterCount , setActiveQuickFIlterCount] = useState(0);

  const newTagValidationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
  });


  const handleSubmit = async (values) => {
    const customTag = tagsList?.find((tag) => tag.name === 'Custom Tags');
    const payload = {
      ...customTag,
      childTags: values?.id
        ? customTag?.childTags.map((item) =>
            item.id === values.id ? values : item,
          )
        : [
            ...(customTag?.childTags ?? []),
            {
              ...values,
              parentCategory: values.parentCategory || customTag?.id || 0,
              floristId: values.floristId || user.floristId,
            },
          ],
    };
    const response = await addNewTag({ body: payload });
    if (!response?.data?.error) {
      toast.success('Tag Added');
    }
    getCategories();
    getProductTags();
    setShowAddTag(false);
  };

  /* Quick Filter */
  const [showQuickFliters, setShowQuickFilters] = useState(false);
  /* Top Filter */
  const [showTopFliters, setShowTopFilters] = useState(false);




  const [sideBarTopTagSelection, setSideBarTopTagSelection] = useState(
    listing?.tag?.filter((tag) => tag.parentCategory === 5) || [],
  );

  /* Occasion Tags */
  const [showOccasionFliters, setShowOccasionFilters] = useState(false);
  const [sideBarOccasionTagSelection, setSideBarOccasionTagSelection] =
    useState(listing?.tag?.filter((tag) => tag.parentCategory === 22) || []);

  /* Flower Tags */
  const [showFlowerFliters, setShowFlowerFilters] = useState(false);
  const [sideBarFlowerTagSelection, setSideBarFlowerTagSelection] = useState(
    listing?.tag?.filter((tag) => tag.parentCategory === 44) || [],
  );

  /* Custom Tags */
  const [showCustomTagFliters, setShowCustomTagFilters] = useState(false);
  const customTag = tagsList?.find((tag) => tag.name === 'Custom Tags')?.id;
  const [sideBarCustomTagSelection, setSideBarCustomTagSelection] = useState(
    listing?.tag?.filter((tag) => tag.parentCategory === customTag) || [],
  );
  const userPermissions = useSelector(
    (state) => state?.authorization?.userPermissions,
  );

  const has_permission_to_add_product = isAuthorized(
    userPermissions,
    'add_product',
  );

  useEffect(() => {
    setFilterValues(
      JSON.parse(localStorage.getItem(`filterValues-${getName(location)}`)) ?? {
        ...defaultListing,
        ...(!isCatalogue ? {hidden: false } : {}),
      },
    );
    setSelectedProducts([]);
  }, [location.pathname]);

  useEffect(() => {
    if (sideBarTopTagSelection.length === 0) {
      setSideBarTopTagSelection(
        (filterValues?.tags || []).filter((tag) => tag.parentCategory === 5),
      );
    }
    if (sideBarOccasionTagSelection.length === 0) {
      setSideBarOccasionTagSelection(
        (filterValues?.tags || []).filter((tag) => tag.parentCategory === 22),
      );
    }
    if (sideBarFlowerTagSelection.length === 0) {
      setSideBarFlowerTagSelection(
        (filterValues?.tags || []).filter((tag) => tag.parentCategory === 44),
      );
    }
    if (sideBarCustomTagSelection.length === 0) {
      setSideBarCustomTagSelection(
        (filterValues?.tags || []).filter(
          (tag) => tag.parentCategory === customTag,
        ),
      );
    }
    if (selectedFlorists?.length === 0) {
      setSelectedFlorists(filterValues?.contributedFloristId ?? []);
    }
  }, [filterValues]);

  const activeFilterCount =
    (listing.tags?.length ?? 0) +
    (listing.category?.length ?? 0) +
    (listing.price?.[0] !== 0 || listing.price?.[1] !== 1000 ? 1 : 0) +
    (listing.minVotes !== undefined && listing.minVotes !== '' ? 1 : 0) +
    (listing.minSold !== undefined && listing.minSold !== '' ? 1 : 0) +
    (listing.startDate || listing.endDate ? 1 : 0) +
    (!isCatalogue
      ? (listing?.stockStatus !== undefined ? 1 : 0) +
        (listing?.variationStockStatus ? 1 : 0) +
        (listing?.deactivated !== undefined ? 1 : 0) +
        (listing?.hidden ? 1 : 0) +
        (listing?.availabilityDateSet ? 1 : 0) +
        (listing?.localDeliveryOnly ? 1 : 0)
      : 0) +
    (isProduct || (isCatalogue && isSelectProduct)
      ? (Array.isArray(listing?.Catalog) &&
        listing?.Catalog?.includes('contributed')
          ? 1
          : 0) +
        (Array.isArray(listing?.Catalog) &&
        listing.Catalog.includes('catalogItem')
          ? 1
          : 0)
      : 0);

     

      useEffect(() => {
        const commonFlorists = listing?.contributedFloristId?.filter((florist) =>
          floristData && Object.keys(floristData).some((key) => key == florist) // Ensure both key and florist are strings
        ) || [];
        setSelectedFlorists(commonFlorists);
        const count =
          (listing?.contributedFloristId?.length > 0
            ? listing?.contributedFloristId.filter(
                (florist) =>
                  floristData &&
                  Object.keys(floristData).some(
                    (key) => key == florist,
                  ),
              ).length
            : 0) +
          (listing.tags?.filter((florist) => florist.parentCategory === 5)
            .length > 0
            ? listing.tags?.filter((florist) => florist.parentCategory === 5)
                .length
            : 0) +
          (listing.tags?.filter((florist) => florist.parentCategory === 22)
            .length > 0
            ? listing.tags?.filter((florist) => florist.parentCategory === 22)
                .length
            : 0) +
          (listing.tags?.filter(
            (florist) => florist.parentCategory === customTag,
          ).length > 0
            ? listing.tags?.filter(
                (florist) => florist.parentCategory === customTag,
              ).length
            : 0) +
          (listing.tags?.filter((florist) => florist.parentCategory === 44)
            .length > 0
            ? listing.tags?.filter((florist) => florist.parentCategory === 44)
                .length
            : 0);

        setActiveQuickFIlterCount(count);
      }, [isProduct, floristData, listing]);

  const [getAllNewProductCategories] = useGetAllNewCategoriesMutation();
  const getCategories = async () => {
    const { data } = await getAllNewProductCategories({
      page: 0,
      size: 200,
    });
    const options = await data?.options?.map((option) => ({
      ...option,
      value: option.title,
      label: option.title,
    }));
    setProductCategoryOptions(options);
  };

  const handleTopTagsChange = (item) => {
    if (sideBarTopTagSelection?.some((_item) => _item.id === item.id)) {
      const payload = sideBarTopTagSelection?.filter(
        (_item) => _item.id !== item.id,
      );
      setSideBarTopTagSelection(payload);
    } else {
      const payload = [...sideBarTopTagSelection, item];
      setSideBarTopTagSelection(payload);
    }
  };

  const handleOccasionTagsChange = (item) => {
    if (sideBarOccasionTagSelection?.some((_item) => _item.id === item.id)) {
      const payload = sideBarOccasionTagSelection?.filter(
        (_item) => _item.id !== item.id,
      );
      setSideBarOccasionTagSelection(payload);
    } else {
      const payload = [...sideBarOccasionTagSelection, item];
      setSideBarOccasionTagSelection(payload);
    }
  };

  const handleFlowerTagsChange = (item) => {
    if (sideBarFlowerTagSelection?.some((_item) => _item.id === item.id)) {
      const payload = sideBarFlowerTagSelection?.filter(
        (_item) => _item.id !== item.id,
      );
      setSideBarFlowerTagSelection(payload);
    } else {
      const payload = [...sideBarFlowerTagSelection, item];
      setSideBarFlowerTagSelection(payload);
    }
  };

  const handleCustomTagsChange = (item) => {
    if (sideBarCustomTagSelection?.some((_item) => _item.id === item.id)) {
      const payload = sideBarCustomTagSelection?.filter(
        (_item) => _item.id !== item.id,
      );
      setSideBarCustomTagSelection(payload);
    } else {
      const payload = [...sideBarCustomTagSelection, item];
      setSideBarCustomTagSelection(payload);
    }
  };

  const handleTopTagsSelection = (item) => {
    // Check if the selectedTopTags array already contains the 'item' being clicked
    if (selectedTopTags?.some((_item) => _item.id === item.id)) {
      // If the 'item' exists in the selectedTopTags array, it means we're unselecting it
      // Filter out the 'item' from the selectedTopTags array by checking if its id doesn't match
      const payload = selectedTopTags?.filter((_item) => _item.id !== item.id);

      // Update the selectedTopTags state to the new filtered array (i.e., without the unselected 'item')
      setSelectedTopTags(payload);
    } else {
      // If the 'item' is not already in selectedTopTags, it means we're selecting it
      // Create a new array by spreading the existing selectedTopTags and adding the new 'item' to it
      const payload = [...selectedTopTags, item];

      // Update the selectedTopTags state with the new array (i.e., including the newly selected 'item')
      setSelectedTopTags(payload);
    }
  };

  const handleApply = () => {
    const addTagDTOS = selectedTopTags
      ?.filter(
        (tag) =>
          !initialSelectedTopTags?.some(
            (initialTag) => initialTag.id === tag.id,
          ), // Filter out tags already in initialSelectedTopTags
      )
      .map((tag) => ({
        id: tag.id, // Only add new tags' IDs
        name: tag.name,
      }));

    const addTagDTOSHelper = selectedTopTags?.map((tag) => ({
      id: tag.id,
      name: tag.name,
    }));

    const removeTagDTOS = initialSelectedTopTags
      ?.map((tag) => ({
        id: tag.id,
        name: tag.name,
      }))
      ?.filter((_tag) => !addTagDTOSHelper?.some((tag) => tag.id === _tag.id));

    const payload = {
      addTagDTOS,
      removeTagDTOS,
      inventoryDTOS: selectedProducts,
    };

    handleBulkEditTopTags(payload);
  };

  const handleHideCatalog = () => {
    setListing((prevState) => {
      const {page , ...updatedListing} = {
        ...prevState,
        onlyMe: !prevState.onlyMe,
      };

      // Update localStorage with the updated listing
      localStorage.setItem(
        `filterValues-${getName(location)}`,
        JSON.stringify(updatedListing),
      );

      // Trigger reinitialization of Formik
      formikRef.current?.setValues(updatedListing); // Use ref to access Formik instance

      return updatedListing; // Return the updated listing to update the state
    });
  };

  const handleTopTagApply = () => {
    setListing((prevState) => {
      const updatedTags = [
        ...prevState.tags.filter((tag) => tag.parentCategory !== 5), // Keep tags without parentCategory 5
        ...sideBarTopTagSelection, // Add the new tags from sideBarTopTagSelection
      ];

      const {page , ...updatedListing} = {
        ...prevState,
        tags: updatedTags, // Update the tags in the state
      };

      // Update localStorage with the updated listing
      localStorage.setItem(
        `filterValues-${getName(location)}`,
        JSON.stringify(updatedListing),
      );

      // Trigger reinitialization of Formik
      formikRef.current?.setValues(updatedListing); // Use ref to access Formik instance

      return updatedListing; // Return the updated listing to update the state
    });
  };

  const handleOccasionTagApply = () => {
    setListing((prevState) => {
      const updatedTags = [
        ...prevState.tags.filter((tag) => tag.parentCategory !== 22), // Keep tags without parentCategory 5
        ...sideBarOccasionTagSelection, // Add the new tags from sideBarOccasionTagSelection
      ];

      const {page , ...updatedListing} = {
        ...prevState,
        tags: updatedTags, // Update the tags in the state
      };

      // Update localStorage with the updated listing
      localStorage.setItem(
        `filterValues-${getName(location)}`,
        JSON.stringify(updatedListing),
      );

      // Trigger reinitialization of Formik
      formikRef.current?.setValues(updatedListing); // Use ref to access Formik instance

      return updatedListing; // Return the updated listing to update the state
    });
  };

  const handleFlowerTagApply = () => {
    setListing((prevState) => {
      const updatedTags = [
        ...prevState.tags.filter((tag) => tag.parentCategory !== 44), // Keep tags without parentCategory 5
        ...sideBarFlowerTagSelection, // Add the new tags from sideBarFlowerTagSelection
      ];

      const {page , ...updatedListing} = {
        ...prevState,
        tags: updatedTags, // Update the tags in the state
      };

      // Update localStorage with the updated listing
      localStorage.setItem(
        `filterValues-${getName(location)}`,
        JSON.stringify(updatedListing),
      );

      // Trigger reinitialization of Formik
      formikRef.current?.setValues(updatedListing); // Use ref to access Formik instance

      return updatedListing; // Return the updated listing to update the state
    });
  };

  const handleCustomTagApply = () => {
    setListing((prevState) => {
      const updatedTags = [
        ...prevState.tags.filter((tag) => tag.parentCategory !== customTag), // Keep tags without parentCategory 5
        ...sideBarCustomTagSelection, // Add the new tags from sideBarCustomTagSelection
      ];

      const {page , ...updatedListing} = {
        ...prevState,
        tags: updatedTags, // Update the tags in the state
      };

      // Update localStorage with the updated listing
      localStorage.setItem(
        `filterValues-${getName(location)}`,
        JSON.stringify(updatedListing),
      );

      // Trigger reinitialization of Formik
      formikRef.current?.setValues(updatedListing); // Use ref to access Formik instance

      return updatedListing; // Return the updated listing to update the state
    });
  };

  const handleFloristTagApply = () => {
    setListing((prevState) => {
      const { page, ...updatedListing } = {
        ...prevState,
        contributedFloristId: selectedFlorists.map((id) => Number(id)), // Update the tags in the state
      };

      // Update localStorage with the updated listing
      localStorage.setItem(
        `filterValues-${getName(location)}`,
        JSON.stringify(updatedListing),
      );

      // Trigger reinitialization of Formik
      formikRef.current?.setValues(updatedListing); // Use ref to access Formik instance

      return updatedListing; // Return the updated listing to update the state
    });
  };

  const handleCancel = () => {
    setSelectedTopTags([]);
    setSelectedProducts([]);
  };

  const handleUpdateStatus = () => {
    updateProductStatus({
      activate: makeProductActive,
      inventoryDTOS: selectedProducts.map((id) => ({ id })),
    })
      .then((data) => {
        if (!data?.error) {
          toast.success('Product Status Updated Successfully');
          setUpdatingTag(true);
          refetch();
        }
      })
      .catch((error) => {
        console.error('Error updating product status:', error);
      });
  };

   const handleUpdateStockStatus = () => {
      setUpdatingTag(true);
      updateProductStockStatus({
        stockStatus: makeProductAvailable,
        inventoryDTOS: selectedProducts.map((id) => ({ id })),
      })
        .then((data) => {
          if (!data?.error) {
            toast.success('Product Status Updated Successfully');
            refetch();
          }
        })
        .catch((error) => {
          console.error('Error updating product status:', error);
        });
    };

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    if (data?.objectData?.content) {
      const selectedFullProducts = data?.objectData?.content?.filter((item) =>
        selectedProducts.includes(item.id),
      );

      const productsTagsArray = selectedFullProducts.map(
        (item) => item[TAGS_FIELD_KEY],
      );

      const topTags =
        productTags?.find((item) => item.label === 'Top Tags')?.childTags ?? [];

      const commonTags =
        topTags?.filter((topTag) =>
          productsTagsArray?.every((tagArray) =>
            tagArray?.some((tag) => tag.id === topTag.id),
          ),
        ) ?? [];

      setInitialSelectedTopTags(commonTags);
      setSelectedTopTags(commonTags);
    }
  }, [selectedProducts, data?.objectData?.content, productTags]);

  useEffect(() => {}, [selectedSort]);

  const handleSearch = _.debounce((submitForm) => {
    submitForm();
  }, 500);

  return (
    <>
      <div className="d-flex flex-wrap align-items-md-center justify-content-between flex-column flex-md-row">
        <div className="d-flex align-items-center gap-3 mt-0 mb-1 mb-md-0 flex-wrap">
          {isCatalogue && location.pathname !== '/products' && (
            <>
              {selectedProducts?.length > 0 && (
                <ShopStyled.EditButton
                  color={'primary'}
                  padding="7px 14px"
                  childrenProps={{
                    className: 'd-flex align-items-center gap-2',
                  }}
                  onClick={async () => {
                    setAddtoMyProducts(true);
                    const { data } = await addCatalogueAPI(
                      selectedProducts?.map((item) => ({ id: item })) || [],
                    );
                    if (!data?.error) {
                      toast.success(
                        data?.description ||
                          'Inventory Catalog Saved Successfully',
                      );
                      isComingFromEditTemplate
                        ? onHandleButtonActionForTemplate()
                        : refetch();
                    }
                    setAddtoMyProducts(false);
                  }}
                >
                  <AddIcon />
                  <ShopStyled.ButtonText>
                    Add to My Products
                  </ShopStyled.ButtonText>
                </ShopStyled.EditButton>
              )}
            </>
          )}

          {!isSelectProduct && selectedProducts?.length === 0 && (
            <OverlayTrigger
              overlay={
                !has_permission_to_add_product && isProduct ? (
                  <StyledTooltip>
                    You do not have permission to Add New product
                  </StyledTooltip> // Show tooltip if unauthorized and isProduct is true
                ) : (
                  <></> // No tooltip otherwise
                )
              }
            >
              <div
                style={{
                  opacity:
                    !has_permission_to_add_product && isProduct ? 0.6 : 1, // Opacity adjustment
                  cursor:
                    !has_permission_to_add_product && isProduct
                      ? 'not-allowed'
                      : 'pointer',
                }}
              >
                <AddToProductButton
                  color={'primary'}
                  padding="7px 14px"
                  className={`${
                    !has_permission_to_add_product && isProduct
                      ? 'cursor-not-allowed'
                      : 'cursor-pointer'
                  }`}
                  childrenProps={{
                    className: `d-flex align-items-center gap-2 ${
                      !has_permission_to_add_product && isProduct
                        ? 'cursor-not-allowed'
                        : 'cursor-pointer'
                    }`,
                  }}
                  onClick={() => {
                    if (!has_permission_to_add_product && isProduct) {
                      return;
                    }
                    if (isComingFromEditTemplate) {
                      onHandleButtonActionForTemplate('addproduct');
                    } else {
                      navigate(
                        isProduct ? '/settings/products/new' : '/products/new',
                      );
                    }
                  }}
                >
                  <AddIcon />
                  <ShopStyled.ButtonText>Add Product</ShopStyled.ButtonText>
                </AddToProductButton>
              </div>
            </OverlayTrigger>
          )}

          {selectedProducts?.length === 0 && (
            <div className="d-flex align-items-center gap-2">
              <StyledSpan
                style={{ position: 'relative' }}
                onClick={() => {
                  setShowQuickFilters(!showQuickFliters);
                  setShowFloristFilters(false);
                  setShowTopFilters(false);
                  setShowOccasionFilters(false);
                  setShowFlowerFilters(false);
                  setShowCustomTagFilters(false);
                }}
                className="py-2 px-2 d-flex justify-content-center align-items-center"
              >
                <StyledText
                  color="bodyMedium"
                  $fontSize="16px"
                  $fontWeight="400"
                  style={{
                    whiteSpace: 'nowrap',
                    marginBottom: '0',
                    marginTop: '0',
                  }}
                >
                  <span className="d-flex flex-row">
                    <span>Quick Filters</span>
                  </span>
                </StyledText>
                <div
                  style={{
                    transform: `rotate(${!showQuickFliters ? '0' : '180'}deg)`,
                  }}
                >
                  <BottomArrow width={20} height={20} />
                </div>
                {activeQuickFilterCount > 0 && (
                  <FilterSuperscript
                    quickFilters={true}
                    active={activeQuickFilterCount}
                    color={'dark30'}
                  >
                    {activeQuickFilterCount}
                  </FilterSuperscript>
                )}
              </StyledSpan>
              {isProduct && (
                <StyledToogleButton
                  className="ml-2"
                  disableText="Show Only My Products"
                  enableText="Show Only My Products"
                  width="175px"
                  height="42px"
                  lableFontSize="14px"
                  active={listing && listing?.onlyMe}
                  onChange={(checked) => {
                    handleHideCatalog(checked);
                  }}
                />
              )}
            </div>
          )}

          {selectedProducts?.length > 0 && !isCatalogue && (
            <ShopStyled.EditButton
              color={'white'}
              type={'error'}
              padding="7px 14px"
              onClick={onDeleteProducts}
              childrenProps={{
                className: 'd-flex align-items-center gap-2',
              }}
            >
              <NewTrashIcon />
              <ShopStyled.ButtonText>Delete</ShopStyled.ButtonText>
            </ShopStyled.EditButton>
          )}
          {selectedProducts?.length > 0 && isProduct && (
            <>
              <Dropdown as={ButtonGroup}>
                <CustomDropDownToggle id="dropdown-basic">
                  Activate/Deactivate
                </CustomDropDownToggle>

                <CustomDropDownMenu>
                  <CustomDropDownItem
                    draggable="false"
                    onClick={() => {
                      setOpenUpdateStatusModal(true);
                      setMakeProductActive(true);
                    }}
                  >
                    Activate
                  </CustomDropDownItem>
                  <CustomDropDownItem
                    draggable="false"
                    onClick={() => {
                      setOpenUpdateStatusModal(true);
                      setMakeProductActive(false);
                    }}
                  >
                    Deactivate
                  </CustomDropDownItem>
                </CustomDropDownMenu>
              </Dropdown>
            </>
          )}

          {selectedProducts?.length > 0 && isProduct && (
            <>
              <Dropdown as={ButtonGroup}>
                <CustomDropDownToggle id="dropdown-basic">
                  Stock Status
                </CustomDropDownToggle>

                <CustomDropDownMenu>
                  <CustomDropDownItem
                    draggable="false"
                    onClick={() => {
                      setUpdateStockStatusModal(true);
                      setMakeProductAvailable(true);
                    }}
                  >
                    In Stock
                  </CustomDropDownItem>
                  <CustomDropDownItem
                    draggable="false"
                    onClick={() => {
                      setUpdateStockStatusModal(true);
                      setMakeProductAvailable(false);
                    }}
                  >
                    Out of Stock
                  </CustomDropDownItem>
                </CustomDropDownMenu>
              </Dropdown>
            </>
          )}
        </div>
        <div className="d-xl-flex d-block align-items-center">
          <StyledProduct.HeaderFilter className="mt-2 mt-xxl-0">
            <Formik
              innerRef={formikRef} // Attach the ref
              initialValues={filterValues}
              enableReinitialize
              onSubmit={(values) => {
                if (showFilterDropDown) {
                  return;
                }
                setShowFilterDropDown(false);
                setListing((prev) => {
                  const { stockStatus, deactivated, ...prevValues } = prev;
                  return {
                    ...prevValues,
                    ...values,
                  };
                });
              }}
            >
              {({
                values,
                setFieldValue,
                resetForm,
                submitForm,
                setValues,
              }) => (
                <Form className="product-filter">
                  <div className="d-flex flex-wrap p-0 filter-part-main">
                    <div className="d-flex  search-category-part flex-wrap">
                      {isCatalogue && (
                        <CustomDropdownStyle
                          autoClose={'inside'}
                          menuClassName="new-menu filter-dropdown"
                          className="custom-drop-down w-auto drop-down border-0 bg-transparent d-none d-md-block"
                          toggleClassName={
                            'table-dropdown ms-0 table-text p-0 border-0 new-font '
                          }
                          menuProps={{
                            align: 'end',
                            style: {
                              maxWidth: '300px',
                              inset: '0 auto auto 0 !important',
                            },
                          }}
                          dropDownToggleProps={{
                            as: 'div',
                          }}
                          dropdownToggle={
                            <span
                              style={{
                                borderRadius: '5px',
                                border: '1px solid #E0E0E0',
                                userSelect: 'none',
                              }}
                              className="flex-center py-2 px-3 w-100 justify-content-between new-font cursor-pointer"
                            >
                              <h6
                                style={{ color: '#A3A3A3', userSelect: 'none' }}
                                className="me-1 me-lg-2 mb-0 trucate"
                              >
                                Sort by:{' '}
                                <span
                                  style={{
                                    color: '#4E4E4E',
                                    userSelect: 'none',
                                  }}
                                >
                                  {selectedSort}
                                </span>
                              </h6>
                              <BottomArrow
                                className="ms-auto"
                                rotate="down"
                                width="24px"
                                height="24px"
                              />
                            </span>
                          }
                          size="small"
                          dropdownMenu={
                            <div
                              style={{
                                maxHeight: '400px',
                                overflow: 'auto',
                                userSelect: 'none',
                              }}
                            >
                              <DropdownItem
                                // key={item}
                                onClick={() => {
                                  setSelectedSort('Most Recent');
                                  setFieldValue('mostUpVoted', false);
                                  setFieldValue('recentlyAdded', true);
                                  setFieldValue('mostSold', false);

                                  submitForm();
                                }}
                              >
                                Most Recent
                              </DropdownItem>
                              <DropdownItem
                                onClick={() => {
                                  setSelectedSort('Most Upvoted');
                                  setFieldValue('mostUpVoted', true);
                                  setFieldValue('recentlyAdded', false);
                                  setFieldValue('mostSold', false);

                                  submitForm();
                                }}
                              >
                                Most Upvoted
                              </DropdownItem>
                              <DropdownItem
                                // key={item}
                                onClick={() => {
                                  setSelectedSort('Most Sold');
                                  setFieldValue('mostUpVoted', false);
                                  setFieldValue('recentlyAdded', false);
                                  setFieldValue('mostSold', true);

                                  submitForm();
                                }}
                              >
                                Most Sold
                              </DropdownItem>
                            </div>
                          }
                        />
                      )}

                      <div className="search-bar">
                        <StyledSearchInput
                          id={'search'}
                          padding="8px 16px"
                          stroke={theme.dark70}
                          value={values.search ?? ''}
                          size="product"
                          searchIconClassName="search-icon dark40"
                          placeHolder="Search by Keyword"
                          $phFontSize="16px"
                          onChange={(e) => {
                            setFieldValue('search', e.target.value);
                            handleSearch(submitForm);
                          }}
                          onReset={() => {
                            setFieldValue('search', '');
                            _.debounce(() => {
                              submitForm();
                            }, 500)();
                          }}
                          $phColor={'bodyMedium'}
                          $iconColor="dark40"
                          svgSize={'24px'}
                        />
                      </div>

                      <ShopStyled.EditButton
                        active={view === 'table'}
                        onClick={() => setView('table')}
                        color={'dark70'}
                        type={'icon-btn'}
                        padding="7px 14px"
                        className="bg-transparent"
                        childrenProps={{
                          className: 'd-flex align-items-center gap-2',
                        }}
                      >
                        <TableViewIcon />
                      </ShopStyled.EditButton>

                      <ShopStyled.EditButton
                        active={view === 'grid'}
                        onClick={() => setView('grid')}
                        color={'dark70'}
                        type={'icon-btn'}
                        padding="7px 14px"
                        className="bg-transparent"
                        childrenProps={{
                          className: 'd-flex align-items-center gap-2',
                        }}
                      >
                        <GridviewIcon />
                      </ShopStyled.EditButton>

                      <ShopStyled.EditButton
                        onClick={() => setView('list')}
                        active={view === 'list'}
                        color={'dark70'}
                        type={'icon-btn'}
                        padding="7px 14px"
                        className="bg-transparent"
                        childrenProps={{
                          className: 'd-flex align-items-center gap-2',
                        }}
                      >
                        <ListViewIcon />
                      </ShopStyled.EditButton>

                      <CustomDropdownStyle
                        show={showFilterDropDown}
                        autoClose={'inside'}
                        menuClassName="new-menu filter-dropdown"
                        className="custom-drop-down w-auto drop-down border-0 bg-transparent d-none d-md-block"
                        toggleClassName={
                          'table-dropdown ms-0 table-text p-0 border-0 new-font '
                        }
                        menuProps={{
                          align: 'end',
                          style: {
                            minWidth: '1000px',
                            inset: '0 auto auto 0 !important',
                          },
                        }}
                        dropDownToggleProps={{
                          as: 'div',
                        }}
                        dropdownToggle={
                          <ShopStyled.EditButton
                            color={activeFilterCount ? 'dark30' : 'dark70'}
                            active={activeFilterCount}
                            type={'button'}
                            padding="7px 14px"
                            className="h-100"
                            variant={'icon-btn'}
                            childrenProps={{
                              className: 'd-flex align-items-center gap-2',
                            }}
                            onClick={() => {
                              setShowFilterDropDown(!showFilterDropDown);
                              setShowCustomTagFilters(false);
                              setShowOccasionFilters(false);
                              setShowFlowerFilters(false);
                              setShowTopFilters(false);
                              setShowFloristFilters(false);
                            }}
                            border="none"
                          >
                            <NewFilterIcon />
                            {activeFilterCount ? (
                              <FilterSuperscript
                                quickFilters={false}
                                active={activeFilterCount}
                                color={activeFilterCount ? 'dark30' : 'dark70'}
                              >
                                {activeFilterCount}
                              </FilterSuperscript>
                            ) : (
                              <></>
                            )}
                          </ShopStyled.EditButton>
                        }
                        // size="small"
                        dropdownMenu={
                          <FilterPopupMenu
                            setSelectedFlorists={setSelectedFlorists}
                            productCategoryOptions={productCategoryOptions}
                            productTags={productTags}
                            tagsList={tagsList}
                            isCatalogue={isCatalogue}
                            isProduct={isProduct}
                            _listing={listing}
                            values={values}
                            setFieldValue={setFieldValue}
                            setValues={setValues}
                            submitForm={submitForm}
                            setSideBarTopTagSelection={
                              setSideBarTopTagSelection
                            }
                            setSideBarOccasionTagSelection={
                              setSideBarOccasionTagSelection
                            }
                            setSideBarCustomTagSelection={
                              setSideBarCustomTagSelection
                            }
                            setSideBarFlowerTagSelection={
                              setSideBarFlowerTagSelection
                            }
                            customTag={customTag}
                            resetForm={() => {
                              localStorage.removeItem(
                                `filterValues-${getName(location)}`,
                              );
                              setValues({
                                ...defaultListing,
                                ...(!isCatalogue ? { hidden: false } : {}),
                              });
                            }}
                            getCategories={getCategories}
                            getProductTags={getProductTags}
                            isSelectProduct={isSelectProduct}
                            setShowFilterDropDown={setShowFilterDropDown}
                            getName={getName}
                            showAddTag={showAddTag}
                            setShowAddTag={setShowAddTag}
                            user={user}
                            editTagValue={editTagValue}
                            setEditTagValue={setEditTagValue}
                            handleSubmit={handleSubmit}
                          />
                        }
                      />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </StyledProduct.HeaderFilter>
        </div>
      </div>

      <div
        class="quick-action-buttons"
        style={{
          display:
            selectedProducts?.length === 0 && showQuickFliters
              ? 'flex'
              : 'none',
          alignItems: 'center',
          gap: '10px',
          marginTop: '10px',
          marginBottom: '5px',
        }}
      >
        {selectedProducts?.length === 0 &&
          (!isProductFloristsFetching || !isProductFloristsFetching) &&
          !isEmptyOrNullObj(floristData) && (
            <CustomDropdownStyle
              show={showFloristFliters}
              menuClassName="new-menu filter-dropdown"
              className="custom-drop-down w-auto drop-down border-0 bg-transparent d-none d-md-block"
              toggleClassName={
                'table-dropdown ms-0 table-text p-0 border-0 new-font '
              }
              menuProps={{
                align: 'start',
                style: {
                  maxWidth: 'fit-content',
                  width: '100%',
                  minWidth: 'fit-content',
                  inset: '0 0 0 0 !important',
                },
              }}
              dropDownToggleProps={{
                as: 'div',
              }}
              dropdownToggle={
                <span
                  onClick={() => {
                    setShowFloristFilters(!showFloristFliters);
                    setShowTopFilters(false);
                    setShowOccasionFilters(false);
                    setShowFlowerFilters(false);
                    setShowCustomTagFilters(false);
                  }}
                  style={{
                    borderRadius: '5px',
                    border: '1px solid #E0E0E0',
                    userSelect: 'none',
                    cursor: 'pointer',
                    // height : '42px'
                  }}
                  className="py-2 px-2 d-flex justify-content-center align-items-center"
                >
                  <StyledText
                    color="bodyMedium"
                    $fontSize="16px"
                    $fontWeight="400"
                    style={{
                      whiteSpace: 'nowrap',
                      marginBottom: '0',
                      marginTop: '0',
                    }}
                  >
                    <span className="d-flex flex-row">
                      <span>Florists:</span>
                    </span>
                  </StyledText>
                  <div
                    style={{
                      transform: `rotate(${
                        !showFloristFliters ? '0' : '180'
                      }deg)`,
                    }}
                  >
                    <BottomArrow width={20} height={20} />
                  </div>
                  {selectedFlorists?.length > 0 && (
                    <FilterSuperscript
                      quickFilters={true}
                      active={activeFilterCount}
                      color={'dark30'}
                    >
                      {selectedFlorists?.length}
                    </FilterSuperscript>
                  )}
                </span>
              }
              size="small"
              dropdownMenu={
                <div
                  style={{ width: 'max-content' }}
                  className="d-flex flex-column py-2 px-3"
                >
                  {Object.entries(floristData).map(([key, item], index) => {
                    if (item === null) {
                      return null;
                    }
                    return (
                      <Col
                        key={index}
                        xs={12}
                        className="d-flex align-items-center gap-2 mt-2"
                      >
                        <StyledCheckbox
                          value={selectedFlorists.includes(Number(key))}
                          onChange={(e) => {
                            setSelectedFlorists((prev) => {
                              if (e.target.checked) {
                                return [...prev, Number(key)];
                              } else {
                                return prev.filter(
                                  (filter) => filter !== Number(key),
                                );
                              }
                            });
                          }}
                        />
                        <StyledText
                          color={'bodyMedium'}
                          $fontSize={'18px'}
                          $fontWeight={'500'}
                          style={{
                            margin: 0,
                          }}
                        >
                          {item}
                        </StyledText>
                      </Col>
                    );
                  })}
                  <Col>
                    <hr />
                    <FilterButton
                      style={{ height: '35px', width: '100%' }}
                      onClick={() => {
                        setShowFloristFilters(false);
                        setShowTopFilters(false);
                        setShowOccasionFilters(false);
                        setShowFlowerFilters(false);
                        setShowCustomTagFilters(false);
                        handleFloristTagApply();
                      }}
                      loading={updating}
                    >
                      Apply
                    </FilterButton>
                  </Col>
                </div>
              }
            />
          )}

        {/* Top Tags */}
        {selectedProducts?.length === 0 && (
          <CustomDropdownStyle
            show={showTopFliters}
            menuClassName="new-menu filter-dropdown"
            className="custom-drop-down w-auto drop-down border-0 bg-transparent d-none d-md-block"
            toggleClassName={
              'table-dropdown ms-0 table-text p-0 border-0 new-font '
            }
            menuProps={{
              align: 'start',
              style: {
                maxWidth: 'fit-content',
                width: '100%',
                minWidth: 'fit-content',
                inset: '0 0 0 0 !important',
              },
            }}
            dropDownToggleProps={{
              as: 'div',
            }}
            dropdownToggle={
              <span
                onClick={() => {
                  setShowTopFilters(!showTopFliters);
                  setShowFloristFilters(false);
                  setShowOccasionFilters(false);
                  setShowFlowerFilters(false);
                  setShowCustomTagFilters(false);
                }}
                style={{
                  borderRadius: '5px',
                  border: '1px solid #E0E0E0',
                  userSelect: 'none',
                  cursor: 'pointer',
                  // height : '42px'
                }}
                className="py-2 px-2 d-flex justify-content-center align-items-center"
              >
                <StyledText
                  color="bodyMedium"
                  $fontSize="16px"
                  $fontWeight="400"
                  style={{
                    whiteSpace: 'nowrap',
                    marginBottom: '0',
                    marginTop: '0',
                  }}
                >
                  <span className="d-flex flex-row">
                    <span>Top Tags:</span>
                  </span>
                </StyledText>
                <div
                  style={{
                    transform: `rotate(${!showTopFliters ? '0' : '180'}deg)`,
                  }}
                >
                  <BottomArrow width={20} height={20} />
                </div>

                {Object.keys(listing).length > 0 &&
                  listing.tags &&
                  listing.tags.some(
                    (florist) => florist.parentCategory === 5,
                  ) && (
                    <FilterSuperscript
                      quickFilters={true}
                      active={activeFilterCount}
                      color={'dark30'}
                    >
                      {
                        listing.tags.filter(
                          (florist) => florist.parentCategory === 5,
                        ).length
                      }
                    </FilterSuperscript>
                  )}
              </span>
            }
            size="small"
            dropdownMenu={
              <div
                style={{ width: 'max-content' }}
                className="d-flex flex-column py-2 px-3"
              >
                <div
                  style={{
                    maxHeight: '300px',
                    overflowY: 'auto',
                  }}
                >
                  {tagsList
                    ?.find((item) => item.name === 'Top Tags')
                    ?.childTags?.map((tag, index) => {
                      return (
                        <Col
                          xs={12}
                          className="d-flex align-items-center gap-2 mt-2"
                        >
                          <StyledCheckbox
                            value={sideBarTopTagSelection?.some(
                              (item) => item.id === tag.id,
                            )}
                            onChange={() => {
                              handleTopTagsChange(tag);
                            }}
                          />
                          <StyledText
                            color={'bodyMedium'}
                            $fontSize={'18px'}
                            $fontWeight={'500'}
                            style={{
                              margin: 0,
                            }}
                          >
                            {tag.name}
                          </StyledText>
                        </Col>
                      );
                    })}
                </div>
                <Col>
                  <hr />
                  <FilterButton
                    style={{ height: '35px', width: '100%' }}
                    onClick={() => {
                      setShowTopFilters(false);
                      setShowFloristFilters(false);
                      setShowOccasionFilters(false);
                      setShowFlowerFilters(false);
                      setShowCustomTagFilters(false);
                      handleTopTagApply();
                    }}
                  >
                    Apply
                  </FilterButton>
                </Col>
              </div>
            }
          />
        )}

        {/* Occasion Tags */}
        {selectedProducts?.length === 0 && (
          <CustomDropdownStyle
            show={showOccasionFliters}
            menuClassName="new-menu filter-dropdown"
            className="custom-drop-down w-auto drop-down border-0 bg-transparent d-none d-md-block"
            toggleClassName={
              'table-dropdown ms-0 table-text p-0 border-0 new-font '
            }
            menuProps={{
              align: 'start',
              style: {
                maxWidth: 'fit-content',
                width: '100%',
                minWidth: 'fit-content',
                inset: '0 0 0 0 !important',
              },
            }}
            dropDownToggleProps={{
              as: 'div',
            }}
            dropdownToggle={
              <span
                onClick={() => {
                  setShowOccasionFilters(!showOccasionFliters);
                  setShowTopFilters(false);
                  setShowFlowerFilters(false);
                  setShowCustomTagFilters(false);
                  setShowFloristFilters(false);
                }}
                style={{
                  borderRadius: '5px',
                  border: '1px solid #E0E0E0',
                  userSelect: 'none',
                  cursor: 'pointer',
                  // height : '42px'
                }}
                className="py-2 px-2 d-flex justify-content-center align-items-center"
              >
                <StyledText
                  color="bodyMedium"
                  $fontSize="16px"
                  $fontWeight="400"
                  style={{
                    whiteSpace: 'nowrap',
                    marginBottom: '0',
                    marginTop: '0',
                  }}
                >
                  <span className="d-flex flex-row">
                    <span>Occasion Tags:</span>
                  </span>
                </StyledText>
                <div
                  style={{
                    transform: `rotate(${
                      !showOccasionFliters ? '0' : '180'
                    }deg)`,
                  }}
                >
                  <BottomArrow width={20} height={20} />
                </div>
                {listing &&
                  Object.keys(listing).length > 0 &&
                  listing.tags &&
                  listing.tags.some(
                    (florist) => florist.parentCategory === 22,
                  ) && (
                    <FilterSuperscript
                      quickFilters={true}
                      active={activeFilterCount}
                      color={'dark30'}
                    >
                      {
                        listing.tags.filter(
                          (florist) => florist.parentCategory === 22,
                        ).length
                      }
                    </FilterSuperscript>
                  )}
              </span>
            }
            size="small"
            dropdownMenu={
              <div
                style={{ width: 'max-content' }}
                className="d-flex flex-column py-2 px-3"
              >
                <div
                  style={{
                    maxHeight: '300px',
                    overflowY: 'auto',
                  }}
                >
                  {tagsList
                    ?.find((item) => item.name === 'Occasion Tags')
                    ?.childTags?.map((tag, index) => {
                      return (
                        <Col
                          xs={12}
                          className="d-flex align-items-center gap-2 mt-2"
                        >
                          <StyledCheckbox
                            value={sideBarOccasionTagSelection?.some(
                              (item) => item.id === tag.id,
                            )}
                            onChange={() => {
                              handleOccasionTagsChange(tag);
                            }}
                          />
                          <StyledText
                            color={'bodyMedium'}
                            $fontSize={'18px'}
                            $fontWeight={'500'}
                            style={{
                              margin: 0,
                            }}
                          >
                            {tag.name}
                          </StyledText>
                        </Col>
                      );
                    })}
                </div>
                <Col>
                  <hr />
                  <FilterButton
                    style={{ height: '35px', width: '100%' }}
                    onClick={() => {
                      setShowTopFilters(false);
                      setShowFloristFilters(false);
                      setShowCustomTagFilters(false);
                      setShowOccasionFilters(false);
                      setShowFlowerFilters(false);
                      handleOccasionTagApply();
                    }}
                  >
                    Apply
                  </FilterButton>
                </Col>
              </div>
            }
          />
        )}

        {/* Flower Tags */}
        {selectedProducts?.length === 0 && (
          <CustomDropdownStyle
            show={showFlowerFliters}
            menuClassName="new-menu filter-dropdown"
            className="custom-drop-down w-auto drop-down border-0 bg-transparent d-none d-md-block"
            toggleClassName={
              'table-dropdown ms-0 table-text p-0 border-0 new-font '
            }
            menuProps={{
              align: 'start',
              style: {
                maxWidth: 'fit-content',
                width: '100%',
                minWidth: 'fit-content',
                inset: '0 0 0 0 !important',
              },
            }}
            dropDownToggleProps={{
              as: 'div',
            }}
            dropdownToggle={
              <span
                onClick={() => {
                  setShowFlowerFilters(!showFlowerFliters);
                  setShowOccasionFilters(false);
                  setShowTopFilters(false);
                  setShowCustomTagFilters(false);
                  setShowFloristFilters(false);
                }}
                style={{
                  borderRadius: '5px',
                  border: '1px solid #E0E0E0',
                  userSelect: 'none',
                  cursor: 'pointer',
                  // height : '42px'
                }}
                className="py-2 px-2 d-flex justify-content-center align-items-center"
              >
                <StyledText
                  color="bodyMedium"
                  $fontSize="16px"
                  $fontWeight="400"
                  style={{
                    whiteSpace: 'nowrap',
                    marginBottom: '0',
                    marginTop: '0',
                  }}
                >
                  <span className="d-flex flex-row">
                    <span>Flower Type:</span>
                  </span>
                </StyledText>
                <div
                  style={{
                    transform: `rotate(${!showFlowerFliters ? '0' : '180'}deg)`,
                  }}
                >
                  <BottomArrow width={20} height={20} />
                </div>
                {listing &&
                  Object.keys(listing).length > 0 &&
                  listing.tags &&
                  listing.tags.some(
                    (florist) => florist.parentCategory === 44,
                  ) && (
                    <FilterSuperscript
                      quickFilters={true}
                      active={activeFilterCount}
                      color={'dark30'}
                    >
                      {
                        listing.tags.filter(
                          (florist) => florist.parentCategory === 44,
                        ).length
                      }
                    </FilterSuperscript>
                  )}
              </span>
            }
            size="small"
            dropdownMenu={
              <div
                style={{ width: 'max-content' }}
                className="d-flex flex-column py-2 px-3"
              >
                <div
                  style={{
                    maxHeight: '300px',
                    overflowY: 'auto',
                  }}
                >
                  {productTags
                    ?.find((item) => item.id === 44)
                    ?.childTags?.map((tag, index) => {
                      return (
                        <Col
                          xs={12}
                          className="d-flex align-items-center gap-2 mt-2"
                        >
                          <StyledCheckbox
                            value={sideBarFlowerTagSelection?.some(
                              (item) => item.id === tag.id,
                            )}
                            onChange={() => {
                              handleFlowerTagsChange(tag);
                            }}
                          />
                          <StyledText
                            color={'bodyMedium'}
                            $fontSize={'18px'}
                            $fontWeight={'500'}
                            style={{
                              margin: 0,
                            }}
                          >
                            {tag.name}
                          </StyledText>
                        </Col>
                      );
                    })}
                </div>
                <Col>
                  <hr />
                  <FilterButton
                    style={{ height: '35px', width: '100%' }}
                    onClick={() => {
                      setShowTopFilters(false);
                      setShowFloristFilters(false);
                      setShowCustomTagFilters(false);
                      setShowOccasionFilters(false);
                      setShowFlowerFilters(false);
                      handleFlowerTagApply();
                    }}
                  >
                    Apply
                  </FilterButton>
                </Col>
              </div>
            }
          />
        )}

        {/* Custom Tags */}
        {selectedProducts?.length === 0 && (
          <div
            style={{
              display: 'flex',
            }}
          >
            <CustomDropdownStyle
              show={showCustomTagFliters}
              menuClassName="new-menu filter-dropdown"
              className="custom-drop-down w-auto drop-down border-0 bg-transparent d-none d-md-block"
              toggleClassName={
                'table-dropdown ms-0 table-text p-0 border-0 new-font '
              }
              menuProps={{
                align: 'start',
                style: {
                  maxWidth: 'fit-content',
                  width: '100%',
                  minWidth: 'fit-content',
                  inset: '0 0 0 0 !important',
                },
              }}
              dropDownToggleProps={{
                as: 'div',
              }}
              dropdownToggle={
                <span
                  onClick={() => {
                    setShowCustomTagFilters(!showCustomTagFliters);
                    setShowOccasionFilters(false);
                    setShowFlowerFilters(false);
                    setShowTopFilters(false);
                    setShowFloristFilters(false);
                  }}
                  style={{
                    borderRadius: '5px',
                    border: '1px solid #E0E0E0',
                    userSelect: 'none',
                    cursor: 'pointer',
                    // height : '42px'
                  }}
                  className="py-2 px-2 d-flex justify-content-center align-items-center"
                >
                  <StyledText
                    color="bodyMedium"
                    $fontSize="16px"
                    $fontWeight="400"
                    style={{
                      whiteSpace: 'nowrap',
                      marginBottom: '0',
                      marginTop: '0',
                    }}
                  >
                    <span className="d-flex flex-row">
                      <span>Custom Tags:</span>
                    </span>
                  </StyledText>
                  <div
                    style={{
                      transform: `rotate(${
                        !showCustomTagFliters ? '0' : '180'
                      }deg)`,
                    }}
                  >
                    <BottomArrow width={20} height={20} />
                  </div>
                  {listing &&
                    Object.keys(listing).length > 0 &&
                    listing.tags &&
                    listing.tags.some(
                      (florist) => florist.parentCategory === customTag,
                    ) && (
                      <FilterSuperscript
                        quickFilters={true}
                        active={activeFilterCount}
                        color={'dark30'}
                      >
                        {
                          listing.tags.filter(
                            (florist) => florist.parentCategory === customTag,
                          ).length
                        }
                      </FilterSuperscript>
                    )}
                </span>
              }
              size="small"
              dropdownMenu={
                <div
                  style={{ width: 'max-content' }}
                  className="d-flex flex-column py-2 px-3"
                >
                  <div
                    style={{
                      maxHeight: '300px',
                      overflowY: 'auto',
                    }}
                  >
                    {tagsList
                      ?.find((item) => item.name === 'Custom Tags')
                      ?.childTags?.map((tag, index) => {
                        return (
                          <Col
                            xs={12}
                            className="d-flex align-items-center gap-2 mt-2"
                          >
                            <StyledCheckbox
                              value={sideBarCustomTagSelection?.some(
                                (item) => item.id === tag.id,
                              )}
                              onChange={() => {
                                handleCustomTagsChange(tag);
                              }}
                            />
                            <StyledText
                              color={'bodyMedium'}
                              $fontSize={'18px'}
                              $fontWeight={'500'}
                              style={{
                                margin: 0,
                              }}
                            >
                              {tag.name}
                            </StyledText>
                          </Col>
                        );
                      })}
                  </div>

                  <FilterButton
                    textButton
                    style={{
                      paddingBottom: '0px',
                      paddingTop: '6px',
                      textAlign: 'left',
                      height: '25px',
                      paddingLeft: '0px',
                    }}
                    onClick={() => {
                      setShowAddTag(true);
                    }}
                  >
                    <AddIcon size={10} className="mx-2" />
                    Add New Tag
                  </FilterButton>

                  <Col>
                    <hr />
                    <FilterButton
                      style={{ height: '35px', width: '100%' }}
                      onClick={() => {
                        setShowTopFilters(false);
                        setShowFloristFilters(false);
                        setShowOccasionFilters(false);
                        setShowFlowerFilters(false);
                        setShowCustomTagFilters(false);
                        handleCustomTagApply();
                      }}
                    >
                      Apply
                    </FilterButton>
                  </Col>
                </div>
              }
            />
            <div>
              <FilterButton
                textButton
                style={{ paddingLeft: 10, paddingRight: 0 }}
                onClick={() => {
                  setShowCustomTagFilters(false);
                  setShowOccasionFilters(false);
                  setShowFlowerFilters(false);
                  setShowTopFilters(false);
                  setShowFloristFilters(false);
                  setSelectedFlorists([]);
                  localStorage.removeItem(`filterValues-${getName(location)}`);
                  formikRef.current?.setValues({
                    ...defaultListing,
                    ...(!isCatalogue ? { hidden: false } : {}),
                    contributedFloristId: [],
                  });
                  setListing({
                    ...defaultListing,
                    ...(!isCatalogue ? { hidden: false } : {}),
                    contributedFloristId: [],
                  });
                  setSideBarCustomTagSelection([]);
                  setSideBarOccasionTagSelection([]);
                  setSideBarFlowerTagSelection([]);
                  setSideBarTopTagSelection([]);
                }}
              >
                Reset
              </FilterButton>
            </div>
          </div>
        )}
      </div>
      {selectedProducts?.length > 0 && !isSelectProduct && (
        <div className="py-2 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-3">
            <StyledText
              color="bodyMedium"
              $fontSize="16px"
              $fontWeight="600"
              style={{
                whiteSpace: 'nowrap',
              }}
            >
              Top Tags:
            </StyledText>
            <StyledTagContainer>
              {productTags
                ?.find((item) => item.label === 'Top Tags')
                ?.childTags?.map((tag, index) => {
                  return (
                    <StyledHeaderTag
                      active={selectedTopTags?.some(
                        (item) => item.id === tag.id,
                      )}
                      key={index}
                      className="gap-3"
                      onClick={() => handleTopTagsSelection(tag)}
                    >
                      <p>{tag.name}</p>
                      {selectedTopTags?.some((item) => item.id === tag.id) && (
                        <NewCloseIcon
                          className={'align-self-center cursor-pointer'}
                        />
                      )}
                    </StyledHeaderTag>
                  );
                })}
            </StyledTagContainer>
          </div>

          <div className="d-flex align-items-center gap-3 ms-4">
            <FilterButton variant={'outline'} onClick={handleCancel}>
              Cancel
            </FilterButton>
            <FilterButton onClick={handleApply} loading={updating}>
              Apply
            </FilterButton>
          </div>
        </div>
      )}
      <ConfirmationModal
        show={openUpdateStatusModal}
        bodyText={`This will ${
          makeProductActive ? 'activate' : 'deactivate'
        } this Products and will not be seen on product page.`}
        ButtonText={makeProductActive ? 'Activate' : 'Deactivate'}
        onClick={() => {
          handleUpdateStatus();
          setOpenUpdateStatusModal(false);
        }}
        onCancel={() => {
          setMakeProductActive(false);
          setOpenUpdateStatusModal(false);
        }}
      />

      <ConfirmationModal
        show={updateStockStatusModal}
        bodyText={`${
          !makeProductAvailable
            ? 'If you mark the selected products as out of stock, all the variation of the selected products will be marked as out of stock.'
            : 'The Selected products will now be available for purchase.'
        }`}
        ButtonText={'Confirm'}
        onClick={() => {
          handleUpdateStockStatus();
          setUpdateStockStatusModal(false);
        }}
        onCancel={() => {
          setMakeProductActive(false);
          setUpdateStockStatusModal(false);
        }}
      />

      <AddCutomTagModal
        showAddTag={showAddTag}
        setShowAddTag={setShowAddTag}
        editTagValue={editTagValue}
        newTagValidationSchema={newTagValidationSchema}
        handleSubmit={handleSubmit}
      />
    </>
  );
};

const FilterPopupMenu = ({
  setSelectedFlorists,
  productCategoryOptions,
  productTags,
  tagsList,
  isCatalogue,
  values,
  setFieldValue,
  setValues,
  submitForm,
  resetForm,
  getCategories,
  getProductTags,
  isProduct,
  isSelectProduct,
  setShowFilterDropDown,
  setSideBarTopTagSelection,
  setSideBarOccasionTagSelection,
  setSideBarFlowerTagSelection,
  setSideBarCustomTagSelection,
  getName,
  showAddTag,
  setShowAddTag,
  user,
  customTag,
  editTagValue,
  setEditTagValue,
  handleSubmit
}) => {
  const [selectedTab, setSelectedTab] = useState('Tags');
  const location = useLocation();
  const handleReset = () => {
    setSelectedFlorists([]);
    setShowFilterDropDown(false);
    setSelectedTab('Tags');
    resetForm();
  };

  useEffect(() => {
    setSelectedTab('Tags');
  }, [isCatalogue]);

  return (
    <Container
      fluid={'lg'}
      className="border-radius-2 d-flex flex-column p-1"
      style={{
        minWidth: '800px',
        minHeight: '625px',
      }}
    >
      <Row className="border-bottom border-grey-30">
        <Col className="px-3 d-flex justify-content-between align-items-center">
          <StyledText
            color="bodyMedium"
            $fontSize="18px"
            $fontWeight="600"
            style={{
              whiteSpace: 'nowrap',
              alignSelf: 'baseline',
              margin: '10px 0',
            }}
          >
            Filter
          </StyledText>
          <Dropdown.Item
            onClick={() => setShowFilterDropDown(false)}
            as={'div'}
            bsPrefix="none"
          >
            <NewCloseIcon size={24} style={{ cursor: 'pointer' }} />
          </Dropdown.Item>
        </Col>
      </Row>

      <Row className="max-vh-70 overflow-auto flex-grow-1">
        <StyledSidebar className="col-auto px-1 border-end border-grey-300">
          {sidebarList
            .filter((item) => (item === 'Status' ? !isCatalogue : true))
            .filter((item) => (item === 'Catalog' ? isProduct : true))
            .filter((item) => (item === 'Default' ? !isProduct : true))
            .map((item, index) => {
              let count = 0;
              if (item === 'Category') count = values.category?.length ?? 0;
              if (item === 'Tags') count = values.tags?.length ?? 0;
              if (item === 'Price')
                count =
                  values.price?.[0] !== 0 || values.price?.[1] !== 1000 ? 1 : 0;
              if (item === 'Status')
                count =
                  (values?.stockStatus !== undefined ? 1 : 0) +
                  (values?.variationStockStatus ? 1 : 0) +
                  (values?.deactivated !== undefined ? 1 : 0) +
                  (values?.hidden ? 1 : 0) +
                  (values?.availabilityDateSet ? 1 : 0) +
                  (values?.localDeliveryOnly ? 1 : 0);
              if (item === 'Catalog') count = values.Catalog?.length ?? 0;
              if (item === 'Default')
                count =
                  (values.minVotes !== undefined && values.minVotes !== ''
                    ? 1
                    : 0) +
                  (values.minSold !== undefined && values.minSold !== ''
                    ? 1
                    : 0) +
                  (values.startDate || values.endDate ? 1 : 0);
              return (
                <CustomTab
                  key={index}
                  onClick={() => setSelectedTab(item)}
                  active={selectedTab === item}
                  className="d-flex justify-content-between align-items-center"
                >
                  <p>{item}</p>
                  {count ? (
                    <div className="count d-flex justify-content-center align-items-center">
                      <p>{count}</p>
                    </div>
                  ) : (
                    <></>
                  )}
                </CustomTab>
              );
            })}
        </StyledSidebar>

        <Col className="d-flex flex-column">
          {selectedTab === 'Category' && (
            <CategoryTags
              tags={productCategoryOptions}
              selection={values.category}
              setSelection={(val) => setFieldValue('category', val)}
            />
          )}

          {selectedTab === 'Tags' && (
            <TagSelector
              tags={productTags}
              tagsList={tagsList}
              selection={values.tags}
              setSelection={(val) => setFieldValue('tags', val)}
              getCategories={getCategories}
              getProductTags={getProductTags}
              setSideBarTopTagSelection={setSideBarTopTagSelection}
              setSideBarOccasionTagSelection={setSideBarOccasionTagSelection}
              setSideBarFlowerTagSelection={setSideBarFlowerTagSelection}
              setSideBarCustomTagSelection={setSideBarCustomTagSelection}
              setShowAddTag={setShowAddTag}
              user={user}
              setEditTagValue={setEditTagValue}
            />
          )}

          {selectedTab === 'Default' && (
            <DefaultFilterOptions
              setFieldValue={setFieldValue}
              setShowFilterDropDown={setShowFilterDropDown}
              values={values}
            />
          )}

          {selectedTab === 'Catalog' && (
            <div className="p-3">
              <ShopStyled.NewFormLabel>
                Catalog
                <OverlayTrigger
                  overlay={<StyledTooltip>Catalog</StyledTooltip>}
                >
                  <span className="cursor-pointer ms-2 ms-md-3 ">
                    <InfoIcon className="mb-1" />
                  </span>
                </OverlayTrigger>
              </ShopStyled.NewFormLabel>
              {isProduct && (
                <Row>
                  {CatalogTagList.map((item, ind) => (
                    <Col
                      xs={12}
                      className="d-flex align-items-center gap-2 mb-2"
                    >
                      <StyledCheckbox
                        label={
                          <StyledText
                            color={'bodyMedium'}
                            $fontSize={'18px'}
                            $fontWeight={'500'}
                            style={{
                              margin: 0,
                            }}
                          >
                            {item.label}
                          </StyledText>
                        }
                        value={values.Catalog.includes(item.value)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setFieldValue('Catalog', [
                              ...values.Catalog,
                              item.value,
                            ]);
                          } else {
                            setFieldValue(
                              'Catalog',
                              values.Catalog.filter(
                                (catalogItem) => catalogItem !== item.value,
                              ),
                            );
                          }
                        }}
                      />
                    </Col>
                  ))}
                </Row>
              )}
            </div>
          )}

          {selectedTab === 'Status' && !isCatalogue && (
            <div className="p-3">
              <ShopStyled.NewFormLabel>
                Status
                <OverlayTrigger overlay={<StyledTooltip>Status</StyledTooltip>}>
                  <span className="cursor-pointer ms-2 ms-md-3 ">
                    <InfoIcon className="mb-1" />
                  </span>
                </OverlayTrigger>
              </ShopStyled.NewFormLabel>
              <Row>
                <Col xs={12} className="d-flex align-items-center gap-2 mb-2">
                  <StyledCheckbox
                    value={values?.stockStatus === false}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setFieldValue('stockStatus', false);
                      } else {
                        const { stockStatus, ...newValues } = values;
                        setValues(newValues);
                      }
                    }}
                  />
                  <StyledText
                    color={'bodyMedium'}
                    $fontSize={'18px'}
                    $fontWeight={'500'}
                    style={{
                      margin: 0,
                    }}
                  >
                    Out of Stock
                  </StyledText>
                </Col>

                <Col xs={12} className="d-flex align-items-center gap-2 mb-2">
                  <StyledCheckbox
                    value={values?.stockStatus === true}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setFieldValue('stockStatus', true);
                      } else {
                        const { stockStatus, ...newValues } = values;
                        setValues(newValues);
                      }
                    }}
                  />
                  <StyledText
                    color={'bodyMedium'}
                    $fontSize={'18px'}
                    $fontWeight={'500'}
                    style={{
                      margin: 0,
                    }}
                  >
                    In Stock
                  </StyledText>
                </Col>

                <Col xs={12} className="d-flex align-items-center gap-2 mb-2">
                  <StyledCheckbox
                    value={values?.variationStockStatus}
                    onChange={(e) => {
                      setFieldValue('variationStockStatus', e.target.checked);
                    }}
                  />
                  <StyledText
                    color={'bodyMedium'}
                    $fontSize={'18px'}
                    $fontWeight={'500'}
                    style={{
                      margin: 0,
                    }}
                  >
                    Product with Out of Stock variation
                  </StyledText>
                </Col>

                <Col xs={12} className="d-flex align-items-center gap-2 mb-2">
                  <StyledCheckbox
                    value={values.deactivated === true}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setFieldValue('deactivated', true);
                      } else {
                        const { deactivated, ...newValues } = values;
                        setValues(newValues);
                      }
                      
                    }}
                  />
                  <StyledText
                    color={'bodyMedium'}
                    $fontSize={'18px'}
                    $fontWeight={'500'}
                    style={{
                      margin: 0,
                    }}
                  >
                    Deactivated
                  </StyledText>
                </Col>

                <Col xs={12} className="d-flex align-items-center gap-2 mb-2">
                  <StyledCheckbox
                    value={values.deactivated === false}
                    onChange={(e) => {
                      if(e.target.checked){
                        setFieldValue('deactivated', false);
                      }
                      else {
                        const { deactivated, ...newValues } = values;
                        setValues(newValues);
                      }
                      
                    }}
                  />
                  <StyledText
                    color={'bodyMedium'}
                    $fontSize={'18px'}
                    $fontWeight={'500'}
                    style={{
                      margin: 0,
                    }}
                  >
                    Activated
                  </StyledText>
                </Col>

                <Col xs={12} className="d-flex align-items-center gap-2 mb-2">
                  <StyledCheckbox
                    value={values.hidden}
                    onChange={(e) => {
                      setFieldValue('hidden', e.target.checked);
                    }}
                  />
                  <StyledText
                    color={'bodyMedium'}
                    $fontSize={'18px'}
                    $fontWeight={'500'}
                    style={{
                      margin: 0,
                    }}
                  >
                    Hidden from product page
                  </StyledText>
                </Col>

                <Col xs={12} className="d-flex align-items-center gap-2 mb-2">
                  <StyledCheckbox
                    value={values.localDeliveryOnly}
                    onChange={(e) => {
                      setFieldValue('localDeliveryOnly', e.target.checked);
                    }}
                  />
                  <StyledText
                    color={'bodyMedium'}
                    $fontSize={'18px'}
                    $fontWeight={'500'}
                    style={{
                      margin: 0,
                    }}
                  >
                    Local Delivery Only
                  </StyledText>
                </Col>
                <Col xs={12} className="d-flex align-items-center gap-2 mb-2">
                  <StyledCheckbox
                    value={values?.availabilityDateSet}
                    onChange={(e) => {
                      setFieldValue('availabilityDateSet', e.target.checked);
                    }}
                  />
                  <StyledText
                    color={'bodyMedium'}
                    $fontSize={'18px'}
                    $fontWeight={'500'}
                    style={{
                      margin: 0,
                    }}
                  >
                    Availability Date is Set
                  </StyledText>
                </Col>
              </Row>
            </div>
          )}

          {selectedTab === 'Price' && (
            <>
              <div className="p-3 w-50">
                <ShopStyled.NewFormLabel>
                  Price
                  <OverlayTrigger
                    overlay={<StyledTooltip>Minimum Price</StyledTooltip>}
                  >
                    <span className="cursor-pointer ms-2 ms-md-3 ">
                      <InfoIcon className="mb-1" />
                    </span>
                  </OverlayTrigger>
                </ShopStyled.NewFormLabel>

                <div className="d-flex gap-2">
                  <div className="w-50">
                    <FormikInputWithIcon
                      name={`price[0]`}
                      placeholder="Min. Price"
                      className="text-end"
                      type="number"
                      formatType="DECIMAL"
                      icon={<>$</>}
                      onChange={(value) => {
                        if (
                          value >= 0 &&
                          value <= 1000 &&
                          value <= values.price[1]
                        ) {
                          setFieldValue('price[0]', value);
                        }
                      }}
                    />
                  </div>

                  <div className="d-flex align-items-center">
                    <StyledText
                      $fontSize={'18px'}
                      $fontWeight={'500'}
                      color={'bodyMedium'}
                    >
                      -
                    </StyledText>
                  </div>

                  <div className="w-50">
                    <FormikInputWithIcon
                      name={`price[1]`}
                      placeholder="Max. Price"
                      className="text-end"
                      type="number"
                      formatType="DECIMAL"
                      icon={<>$</>}
                      onChange={(value) => {
                        if (
                          value >= 0 &&
                          value <= 1000 &&
                          value >= values.price[0]
                        ) {
                          setFieldValue('price[1]', value);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="px-2 mt-2 w-50">
                <FormikRangeSlider
                  name={'price'}
                  min={0}
                  max={1000}
                  stepThreshold={50}
                />
              </div>
            </>
          )}
        </Col>
      </Row>

      <Row>
        <Col className="py-2 px-3 border-top border-grey-300">
          <ButtonToolbar className="justify-content-between">
            <ButtonGroup>
              <Dropdown.Item as={'div'} bsPrefix="none">
                <FilterButton textButton onClick={handleReset}>
                  Reset
                </FilterButton>
              </Dropdown.Item>
            </ButtonGroup>
            <ButtonGroup className="gap-2">
              <Dropdown.Item as={'div'} bsPrefix="none">
                <FilterButton
                  onClick={() => setShowFilterDropDown(false)}
                  variant={'outline'}
                  type={'button'}
                >
                  Cancel
                </FilterButton>
              </Dropdown.Item>
              <Dropdown.Item as={'div'} bsPrefix="none">
                <FilterButton
                  onClick={() => {
                    localStorage.setItem(
                      `filterValues-${getName(location)}`,
                      JSON.stringify(values),
                    );
                    setShowFilterDropDown(false);
                    submitForm();
                  }}
                >
                  Apply
                </FilterButton>
              </Dropdown.Item>
            </ButtonGroup>
          </ButtonToolbar>
        </Col>
      </Row>
    </Container>
  );
};

const DefaultFilterOptions = ({
  setShowFilterDropDown,
  setFieldValue,
  values,
}) => {
  const [dateSelection, setDateSelection] = useState([
    {
      startDate: sub(new Date(), { months: 3 }),
      endDate: new Date(),
      key: 'selection',
    },
  ]);

  const [soldDateSelection, setSoldDateSelection] = useState([
    {
      startDate: sub(new Date(), { months: 3 }),
      endDate: new Date(),
      key: 'selection',
    },
  ]);

  const handleDateChange = (data) => {
    setShowFilterDropDown(true);
    setDateSelection(data);
    setFieldValue(
      'startDate',
      moment(data[0].startDate).format('YYYY-MM-DD HH:mm:ss'),
    );
    setFieldValue(
      'endDate',
      moment(data[0].endDate).format('YYYY-MM-DD HH:mm:ss'),
    );
  };

  const handleSoldDateChange = (data) => {
    setShowFilterDropDown(true);
    setSoldDateSelection(data);
    setFieldValue(
      'soldStartDate',
      moment(data[0].startDate).format('YYYY-MM-DD HH:mm:ss'),
    );
    setFieldValue(
      'soldEndDate',
      moment(data[0].endDate).format('YYYY-MM-DD HH:mm:ss'),
    );
  };

  return (
    <Container>
      <Row>
        <Col className="d-flex flex-row align-items-center py-2">
          <StyledText
            className="mx-2"
            $fontSize={'18px'}
            colorHex="#333333"
            $fontWeight={'500'}
          >
            Added within past
          </StyledText>
          <CustomDateRangePicker
            dateRangeSelection={dateSelection}
            onChange={(data) => handleDateChange(data)}
            className="ms-auto"
          />
        </Col>
      </Row>
      <Row>
        <Col className="d-flex flex-row align-items-center py-2">
          <StyledText
            className="mx-2"
            $fontSize={'18px'}
            colorHex="#333333"
            $fontWeight={'500'}
          >
            At least
          </StyledText>
          <StyledInput
            $phColor="primaryDark"
            $phFontWeight="600"
            placeholder="# Sales"
            type="number"
            value={values?.minSold}
            onChange={(e) => setFieldValue('minSold', e.target.value)}
            style={{ width: '15%' }}
          />
          <StyledText
            className="mx-2"
            $fontSize={'18px'}
            colorHex="#333333"
            $fontWeight={'500'}
          >
            Sold
          </StyledText>
          <CustomDateRangePicker
            disabled={values?.minSold ? false : true}
            dateRangeSelection={soldDateSelection}
            onChange={(data) => handleSoldDateChange(data)}
            className="ms-auto"
          />
        </Col>
      </Row>
      <Row>
        <Col className="d-flex flex-row align-items-center py-2">
          <StyledText
            className="mx-2"
            $fontSize={'18px'}
            colorHex="#333333"
            $fontWeight={'500'}
          >
            At least
          </StyledText>
          <StyledInput
            $phColor="primaryDark"
            $phFontWeight="600"
            type="number"
            placeholder="# Upvotes"
            value={values?.minVotes}
            onChange={(e) => setFieldValue('minVotes', e.target.value)}
            style={{ width: '16%' }}
          />
          <StyledText
            className="mx-2"
            $fontSize={'18px'}
            colorHex="#333333"
            $fontWeight={'500'}
          >
            upvotes
          </StyledText>
        </Col>
      </Row>
      <style>
        {`
         
                    .rdrDateDisplay {
                    margin : 0.53em 0.53em;
                    }
                    .rdrMonthAndYearWrapper {
                    height : 45px;
                    padding-top : 5px;
                    }
                    .rdrMonthName {
                    padding : 0 0.833em;
                    }
                    .rdrInputRanges {
                    padding : 0px 0px ;
                    }
                    .rdrDateDisplayItem{
                    width : 250px;
                    flex : none;
                    }
                    .rdrDateDisplay {
                    justify-content : start;
                    }
                    .footerPosition {
                    position : absolute;
                    right : 10px;
                    top : -3px;
                    border-top : none !important;
                    }
                    .resetBtn {
                    padding : 7px 20px !important;
                    }
                    .applyBtn {
                    padding : 7px 20px !important;
                    }
                    `}
      </style>
    </Container>
  );
};

const CategoryTags = ({ tags, selection, setSelection }) => {
  const handleChange = (item) => {
    if (selection?.some((_item) => _item.id === item.id)) {
      const payload = selection?.filter((_item) => _item.id !== item.id);
      setSelection(payload);
    } else {
      const payload = [...selection, item];
      setSelection(payload);
    }
  };
  return (
    <div>
      {tags?.length > 0 && (
        <div className="d-flex align-items-center gap-3 px-2">
          <StyledTagContainer>
            {tags?.map((tag, index) => {
              return (
                <StyledTag
                  active={selection?.some((item) => item.id === tag.id)}
                  key={index}
                  className="gap-3 mt-3 position-relative"
                  onClick={() => handleChange(tag)}
                >
                  <p>{tag.name}</p>
                  {selection?.some((item) => item.id === tag.id) && (
                    <NewCloseIcon
                      className={'align-self-center cursor-pointer'}
                    />
                  )}
                </StyledTag>
              );
            })}
          </StyledTagContainer>
        </div>
      )}
    </div>
  );
};

const TagSelector = ({
  tags,
  tagsList,
  selection,
  setSelection,
  getCategories,
  getProductTags,
  setSideBarTopTagSelection,
  setSideBarOccasionTagSelection,
  setSideBarFlowerTagSelection,
  setSideBarCustomTagSelection,
  setShowAddTag,
  customTag,
  setEditTagValue,
}) => {

  const [deleteTag] = useDeleteInventoryTagMutation();
  const [showDeletePopUp, setShowDeletePopUp] = useState(false);
  const [deleteTagId, setDeletedTagId] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (item) => {
    if (selection?.some((_item) => _item.id === item.id)) {
      const payload = selection?.filter((_item) => _item.id !== item.id);
      setSelection(payload);
      setSideBarTopTagSelection(
        payload.filter((_item) => _item.parentCategory === 5),
      );
      setSideBarOccasionTagSelection(
        payload.filter((_item) => _item.parentCategory === 22),
      );
      setSideBarFlowerTagSelection(
        payload.filter((_item) => _item.parentCategory === 44),
      );
      setSideBarCustomTagSelection(
        payload.filter((_item) => _item.parentCategory === customTag),
      );
    } else {
      const payload = [...selection, item];
      setSelection(payload);
      setSideBarTopTagSelection(
        payload.filter((_item) => _item.parentCategory === 5),
      );
      setSideBarOccasionTagSelection(
        payload.filter((_item) => _item.parentCategory === 22),
      );
      setSideBarFlowerTagSelection(
        payload.filter((_item) => _item.parentCategory === 44),
      );
      setSideBarCustomTagSelection(
        payload.filter((_item) => _item.parentCategory === customTag),
      );
    }
  };

  const handleDelete = async (id) => {
    if (id === null || id === undefined)
      return toast.error('Cannot delete BoostFloral tag');
    const response = await deleteTag({ id });
    if (!response?.data?.error) {
      toast.success('Tag Deleted');
    }
    getCategories();
    getProductTags();
  };

  return (
    <>
      <Row className="max-vh-70 overflow-auto flex-grow-1">
        <StyledSidebar className="col-auto px-1 border-end border-grey-300">
          {tagsList?.map((item, index) => {
            const count = selection.filter((_item) =>
              item.childTags.some((tag) => _item.id === tag.id),
            )?.length;
            return (
              <CustomTab
                key={index}
                onClick={() => setSelectedTab(index)}
                active={selectedTab === index}
                className="d-flex justify-content-between align-items-center"
              >
                <p>{item.name}</p>
                {count ? (
                  <div className="count d-flex justify-content-center align-items-center">
                    <p>{count}</p>
                  </div>
                ) : (
                  <></>
                )}
              </CustomTab>
            );
          })}
        </StyledSidebar>
        <Col className="mx-4 my-2">
          <div>
            <StyledText
              color="bodyMedium"
              $fontSize="18px"
              $fontWeight="600"
              style={{
                whiteSpace: 'nowrap',
                alignSelf: 'baseline',
                marginTop: 10,
              }}
            >
              Select Tags
            </StyledText>
            <div>
              {tagsList?.[selectedTab]?.childTags?.length > 0 && (
                <div className="d-flex align-items-center gap-3">
                  <StyledTagContainer>
                    {tagsList?.[selectedTab]?.childTags?.map((tag, index) => {
                      return (
                        <StyledTag
                          active={selection?.some((item) => item.id === tag.id)}
                          key={index}
                          className="gap-3 mt-3 position-relative"
                          onClick={() => handleChange(tag)}
                        >
                          <p>{tag.name}</p>
                          {tagsList?.[selectedTab].name === 'Custom Tags' && (
                            <>
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (
                                    tag.floristId !== null ||
                                    tag.floristId !== undefined
                                  ) {
                                    setEditTagValue(tag);
                                    setShowAddTag(true);
                                  }
                                }}
                              >
                                <EditIcon />
                              </div>
                              {!selection?.some(
                                (item) => item.id === tag.id,
                              ) && (
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (
                                      tag.floristId !== null ||
                                      tag.floristId !== undefined
                                    ) {
                                      setDeletedTagId(tag.id);
                                      setShowDeletePopUp(true);
                                    }
                                  }}
                                >
                                  <DeleteIcon />
                                </div>
                              )}
                            </>
                          )}
                          {selection?.some((item) => item.id === tag.id) && (
                            <NewCloseIcon
                              className={'align-self-center cursor-pointer'}
                            />
                          )}
                        </StyledTag>
                      );
                    })}
                  </StyledTagContainer>
                </div>
              )}
            </div>
          </div>
          {tagsList?.[selectedTab].name === 'Custom Tags' && (
            <div className="mt-4">
              <StyledButton onClick={() => setShowAddTag(true)}>
                Add New Tag
              </StyledButton>
            </div>
          )}
        </Col>
      </Row>
      <DeleteConfirmation
        show={showDeletePopUp}
        bodyText={
          'Do you want to delete this tag? This process cannot be undone.'
        }
        onDelete={() => {
          setShowDeletePopUp(false);
          handleDelete(deleteTagId);
        }}
        onCancel={() => {
          setShowDeletePopUp(false);
        }}
      />
    </>
  );
};

const AddCutomTagModal = ({
  showAddTag,
  setShowAddTag,
  editTagValue,
  newTagValidationSchema,
  handleSubmit,
}) => {
  return (
    <Modal show={showAddTag} onHide={() => setShowAddTag(false)} hideActions>
      <Container>
        <Row className="mb-2">
          <Col>
            <StyledText $fontWeight="600" $fontSize="20px" color="headingColor">
              Add New Tag
            </StyledText>
          </Col>
        </Row>
        <Row>
          <Container fluid style={{ minHeight: '200px' }} className="py-4">
            <Row>
              <Formik
                initialValues={editTagValue}
                validationSchema={newTagValidationSchema}
                validateOnChange
                validateOnMount
                onSubmit={handleSubmit}
              >
                {({ values, handleSubmit }) => (
                  <Form>
                    {renderInput({
                      label: 'Tag Name',
                      toolTip: 'Tag name',
                      isRequired: true,
                      component: (
                        <FormikInputWithIcon
                          name={`name`}
                          id={`name`}
                          placeholder="Enter Name"
                        />
                      ),
                    })}

                    <div className="d-flex gap-2 justify-content-end">
                      <StyledButton
                        type="button"
                        variant="outline"
                        onClick={() => {
                          setShowAddTag(false);
                        }}
                      >
                        Cancel
                      </StyledButton>
                      <StyledButton
                        type="button"
                        onClick={() => {
                          handleSubmit(values);
                        }}
                      >
                        Submit
                      </StyledButton>
                    </div>
                  </Form>
                )}
              </Formik>
            </Row>
          </Container>
        </Row>
      </Container>
    </Modal>
  );
};

const StyledSpan = styled.span`
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  user-select: none;
  cursor: pointer;
  gap: 2px;
  background-color: transparent;
  svg {
    color: rgb(38, 7, 53) !important;
    height: 20px;
    width: 20px;
  }
`;

const CustomTab = styled.div`
  background-color: ${({ theme, active }) =>
    active ? theme.primary : 'transparent'};
  color: ${({ theme, active }) => (active ? theme.white : theme.bodyMedium)};
  padding: 10px 20px 10px 10px;
  margin: 5px;
  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;
  font-size: 18px;
  font-weight: 500;
  width: 180px;

  .count {
    background-color: ${({ theme, active }) =>
      active ? theme.white : theme.primary};
    height: 22px;
    width: 22px;
    border-radius: 4px;
    color: ${({ theme, active }) => (active ? theme.primary : theme.white)};
    font-family: Instrument Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.white};

    .count {
      background-color: ${({ theme }) => theme.white};
      color: ${({ theme }) => theme.primary};
    }
  }

  p {
    margin: 0;
  }
`;

const StyledTagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
  gap: 10px;
`;

const StyledTag = styled.span`
  padding: 4px 12px 4px 12px;
  color: ${({ theme, active }) => (active ? theme.white : theme.bodyMedium)};
  font-family: ${(theme) => theme.fontFamily};
  border: 1px solid ${({ theme }) => theme.dark40};
  background-color: ${({ theme, active }) => {
    return active ? theme.badgeText : theme.white;
  }};
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;

  p {
    margin: 0;
  }
`;

const FloristStyledTag = styled.span`
  padding: 2px 8px 2px 8px;
  color: ${({ theme, active }) => (active ? theme.white : theme.bodyMedium)};
  font-family: ${(theme) => theme.fontFamily};
  border: 1px solid ${({ theme }) => theme.dark40};
  background-color: ${({ theme, active }) => {
    return active ? theme.badgeText : theme.white;
  }};
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  margin-left: 7px;

  p {
    margin: 0;
  }
`;

const StyledHeaderTag = styled.span`
  padding: 4px 12px 4px 12px;
  color: ${({ theme, active }) => (active ? theme.white : theme.bodyMedium)};
  font-family: ${(theme) => theme.fontFamily};
  border: 1px solid
    ${({ theme, active }) => (active ? 'transparent' : theme.dark40)};
  background-color: ${({ theme, active }) =>
    active ? theme.badgeText : theme.white};
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;

  p {
    margin: 0;
  }
`;

const FilterButton = styled(StyledButton)`
  ${({ textButton }) =>
    textButton &&
    `
    padding: 10px 20px;
  `}
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 160%;
  height: 45px;
`;

const StyledSidebar = styled(Col)`
  background: ${({ theme }) => theme.primaryLight2};
`;

const FilterSuperscript = styled.p`
  color: #fff;
  font-weight: 500;
  position: absolute;
  top: ${({ quickFilters }) => (quickFilters ? '-7px' : '-4px')};
  font-size: 10px;
  left: ${({ quickFilters }) => (quickFilters ? null : '39px')};
  right: ${({ quickFilters }) => (quickFilters ? '-2px' : null)};
  height: 20px;
  width: 20px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.primary};
`;

export const CustomDropDownToggle = styled(Dropdown.Toggle)`
  background-color: ${({ theme }) => getColor('white', theme)};
  color: ${({ theme }) => getButtonHover('error', theme)};
  border: none;
  font-size: 15px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.11), 0 8px 16px 0 rgba(0, 0, 0, 0.12);

  &:hover {
    background-color: ${({ theme }) => getColor('white', theme)};
    color: ${({ theme }) => getButtonHover('error', theme)};
  }

  &.show {
    background-color: ${({ theme }) => getColor('white', theme)};
    color: ${({ theme }) => getButtonHover('error', theme)};
  }

  &:focus,
  &:active {
    background-color: ${({ theme }) => getColor('white', theme)};
    color: ${({ theme }) => getButtonHover('error', theme)};
  }

  .btn-check:checked + &,
  :not(.btn-check) + &.btn:active,
  &.btn:first-child:active,
  &.btn.active,
  &.btn.show {
    background-color: ${({ theme }) => getColor('white', theme)};
    color: ${({ theme }) => getButtonHover('error', theme)};
  }
`;

export const CustomDropDownMenu = styled(Dropdown.Menu)`
  min-width: 12rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: ${({ theme }) => theme.white};
`;
export const CustomDropDownItem = styled(Dropdown.Item)`
  font-size: 16px;
  font-weight: 500;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  &:focus,
  &:active {
    background-color: ${({ color, theme }) => getDarkenColor('white', theme)};
    color: ${({ theme }) => getButtonHover('error', theme)};
  }
`;

export default ProductsHeader;
